"use strict";
/*
 * This code was generated by
 * ___ _ _ _ _ _    _ ____    ____ ____ _    ____ ____ _  _ ____ ____ ____ ___ __   __
 *  |  | | | | |    | |  | __ |  | |__| | __ | __ |___ |\ | |___ |__/ |__|  | |  | |__/
 *  |  |_|_| | |___ | |__|    |__| |  | |    |__] |___ | \| |___ |  \ |  |  | |__| |  \
 *
 * Twilio - Flex
 * This is the public Twilio REST API.
 *
 * NOTE: This class is auto generated by OpenAPI Generator.
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const Version_1 = __importDefault(require("../../base/Version"));
const flexUser_1 = require("./v2/flexUser");
const webChannels_1 = require("./v2/webChannels");
class V2 extends Version_1.default {
    /**
     * Initialize the V2 version of FlexApi
     *
     * @param domain - The Twilio (Twilio.FlexApi) domain
     */
    constructor(domain) {
        super(domain, "v2");
    }
    /** Getter for flexUser resource */
    get flexUser() {
        this._flexUser = this._flexUser || (0, flexUser_1.FlexUserListInstance)(this);
        return this._flexUser;
    }
    /** Getter for webChannels resource */
    get webChannels() {
        this._webChannels = this._webChannels || (0, webChannels_1.WebChannelsListInstance)(this);
        return this._webChannels;
    }
}
exports.default = V2;
